import { APP_PATH } from "constants/path";
import useBreadcrumb from "hooks/useBreadcrumb";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { translate } from "utils";

import MainInformation from "./components/MainInformation";
import { Tabs } from "antd";
import AnswersComponent from "./components/Answers";
import useQuery from "hooks/useQuery";

const SurveyDetail = () => {
	const { id } = useParams();
	const navigate = useNavigate();
	const { setBreadCrumbs } = useBreadcrumb();
	const { pathname } = useLocation();
	const query = useQuery();

	const [activeKey, setActiveKey] = useState(query.get("tab") || "information");
	const handleChangeTab = (tab: string) => {
		setActiveKey(tab);
		let path = `${pathname}?tab=${tab}`;
		if (query.get("language")) {
			path += `&language=${query.get("language")}`;
		}

		navigate(path);
	};

	useEffect(() => {
		setBreadCrumbs([
			{
				label: translate("Survey"),
				path: APP_PATH.survey,
			},
			{
				label: id ? translate("Survey detail") : translate("Create survey"),
				path: `${APP_PATH.surveyDetail}/${id}`,
			},
		]);
	}, []);

	return (
		<div className="h-full my-4 fade-in bg-white p-4">
			<Tabs activeKey={activeKey} onChange={handleChangeTab}>
				<Tabs.TabPane key={"information"} tab={translate("Information")}>
					<MainInformation id={id!} />
				</Tabs.TabPane>
				<Tabs.TabPane key="answers" tab={translate("Survey answers")}>
					<AnswersComponent id={id!} />
				</Tabs.TabPane>
			</Tabs>
		</div>
	);
};
export default SurveyDetail;
